import { Box, CircularProgress, Grid, Paper } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import ButtonGZ from '../../../components/Button'

import CommentsItem from './components/CommentsItem'
import StyledTab from './components/StyledTab'
import StyledTabs from './components/StyledTabs'
import TabPanel from './components/TabPanel'

import Context from '../../../context'
import history from '../../../services/history'
import CommentsModal from './components/CommentsModal'
import useStyles from './styles'

function DashboardComments() {
  const classes = useStyles()
  const [value, setValue] = useState(1)
  const [openModal, setOpenModal] = useState(false)
  const { isLoading, publicCommentList, privateCommentList, validationsList } = useContext(Context)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Paper className={classes.tabArea}>
      <StyledTabs value={value} onChange={handleChange} aria-label="styled tabs example">
        <StyledTab style={{ fontSize: '25px', fontWeight: 'bold' }} label="COMENTÁRIOS" disabled />
        <StyledTab label="PÚBLICOS" />
        <StyledTab label="PRIVADOS" />
        <Box className={classes.buttonArea}>
          <ButtonGZ
            onClick={() => {
              history.push('/comments')
            }}
          >
            Ver Mais
          </ButtonGZ>
        </Box>
      </StyledTabs>
      {isLoading ? (
        <>
          <TabPanel value={value} index={1}>
            <Grid className={classes.progressArea}>
              <CircularProgress />
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid className={classes.progressArea}>
              <CircularProgress />
            </Grid>
          </TabPanel>
        </>
      ) : (
        <>
          <TabPanel value={value} index={1}>
            {publicCommentList.slice(0, 2).map(item => (
              <Box key={item.id}>
                <CommentsItem key={item.id} data={item} />
              </Box>
            ))}
          </TabPanel>
          <TabPanel value={value} index={2}>
            {privateCommentList.slice(0, 2).map(item => (
              <div key={item.id}>
                <CommentsItem key={item.id} data={item} />
              </div>
            ))}
          </TabPanel>
        </>
      )}
      <Context.Provider
        value={{
          openModal,
          setOpenModal,
          validationsList
        }}
      >
        <CommentsModal />
      </Context.Provider>
    </Paper>
  )
}

export default DashboardComments
